<template>

	<section class="outer-pad opening-panel no-pad-bottom padding-top">

		<div :class="{'info-panel': infoPanel, 'opening-panel-inner': true}">

			<slot name="title" />

			<slot name="content" />

		</div>

	</section>

</template>

<script>
export default {
	name: 'OpeningPanel',
	props: {
		infoPanel: {
			type: Boolean,
			default: true
		}
	},
	data() {

		return {
			
		}

	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.opening-panel {
	.opening-panel-inner {
		position: relative;
	}
	p {
		padding:0;
		margin: 10px 0 0;
		a {
			color: @formDefaultColour;
			text-decoration: none;
			font-weight: 600;
		}
	}
}
</style>